import { useState } from "react";
import { Box, Button, Collapse, Text, VStack, Icon, useTheme } from "@chakra-ui/react";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";

const Programa = ({temas}) => {
  const theme = useTheme();
  const [openTemas, setOpenTemas] = useState(
    new Array(temas.length).fill(false)
  );

  const toggleTema = (index) => {
    setOpenTemas((prev) => {
      const newOpenTemas = [...prev];
      newOpenTemas[index] = !newOpenTemas[index];
      return newOpenTemas;
    });
  };
  if(!temas) return null;
  return (
      <VStack align="stretch" spacing={1}>
        {temas.map((tema, index) => (
          <Box key={index} p={3} pl={4} bg="white" borderRadius="md" boxShadow="sm">
            <Button
              onClick={() => toggleTema(index)}
              variant="ghost"
              justifyContent="flex-start"
              width="full"
              whiteSpace="normal"        // <--- ESTA LÍNEA
              textAlign="left"           // <--- para alinear el texto a la izquierda
              leftIcon={
                <Icon 
                    color={theme.color.text.secondary} 
                    as={openTemas[index] ? MinusIcon : AddIcon} 
                />
              }
              color={theme.color.text.secondary}
            >
              {tema.nombre}
            </Button>
            <Collapse in={openTemas[index]} animateOpacity>
  <Box mt={2} pl={4}>
    {Array.isArray(tema.subtemas) && tema.subtemas.length > 0 ? (
      tema.subtemas.map((subtema, i) => (
        <Box key={i} mt={2} pl={4} borderLeft="2px solid #ccc">
          <Text fontWeight="bold" color={theme.color.text.secondary}>
            {subtema.nombre}
          </Text>
          {subtema.descripcion && (
            <Text color={theme.color.text.secondary} fontSize="sm">
              {subtema.descripcion}
            </Text>
          )}
        </Box>
      ))
    ) : (
      <Text color={theme.color.text.secondary}>
        {tema.descripcion}
      </Text>
    )}
  </Box>
</Collapse>
          </Box>
        ))}
      </VStack>
  );
};

export default Programa;
